import router from '@/router'
const state = {
    bindInfo: {},
    // appId:''
};

const  mutations = {
    updateBindInfo (state, { data }){
        state.bindInfo = data;
        console.log(state)
    },

};

const actions = {
    
    getBindInfo({ state, commit }, context) {
        console.log('getBindInfo=====>');
        console.log('state.appId=====>');
       /*  return context._apis.wechat
            .getAuthResult(window.localStorage.getItem('appid'))
            .then((res) => {
                let { data, code } = res;
                if (code === 200) {
                    commit({
                        type: 'updateBindInfo',
                        data
                    });
                } else {
                    return Promise.reject(res);
                }
                return state.bindInfo;
            }) */
    }
    

};

const getters = {
    bindInfo: state => state.bindInfo,
    // appId: state => state.appId
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}

